skrilla.controller('addCampaignsToMarketModalCtrl', function ($scope, searchService, cacheService, modalService) {
    $scope.market = cacheService.getObject("bettingMarketDetails")?.market;

    $scope.onClick = function (campaign) {
        modalService.confirm("Are you sure you'd like to associate this market with this campaign?", function () {
            searchService.put("campaigns/" + campaign.id + "/bettingMarket", {marketId: $scope.market.id}, "Success. Check logs for details", true)
        })
    }
});